import axios from 'axios';
import * as types from '../../../constant/actionTypes';
import { HOST, EX_DB, } from '../../../constant';

export function fetchDataError(err) {
  return {
    type: types.DATE_LIST_API_ERROR,
    payload: {
      msg: '月報資料請求: ' + err.message + ' 請稍候再試',
    },
  };
}

export function fetchDataSuccess(response) {
  response.data.data.sort((a, b) => {
    const _a = parseInt(a[0] + a[1], 10);
    const _b = parseInt(b[0] + b[1], 10);
    return _b - _a;
  });
  return {
    type: types.DATE_LIST_API_SUCCESS,
    payload: response.data.data,
  };
}

export function fetchDataRequest() {
  return {
    type: types.DATE_LIST_API_REQUEST,
  };
}

const fetchData = (company, authorization) => {
  return (dispatch) => {
    dispatch(fetchDataRequest());
    const options = {
      method: 'GET',
      headers: {
        authorization,
      },
      url: `${HOST}/saber/report/list/select/${EX_DB}/${company}/monthly`,
    };
    return axios(options)
      .then(json => dispatch(fetchDataSuccess(json)))
      .catch(err => dispatch(fetchDataError(err))); // PAGE_ERROR
  };
};

export default fetchData;



// WEBPACK FOOTER //
// ./src/scenes/DateSelect/actions/fetchDateList.js